import React from 'react';
import './style.css';
import { customEmojis } from '../../constants/dropdown';

interface EmojiTrayProps {
    onEmojiClick: (e: any) => void;
    activeEmoji?: string;
}

const EmojiTray: React.FC<EmojiTrayProps> = ({ onEmojiClick, activeEmoji }) => {

    return (
        <div
            className={`emojiTray flex items-start absolute -top-[2rem] -left-[10px] rounded-full h-[30px] shadow-lg p-2 bg-white`}
        >
            {customEmojis.map((item: any, index: any) => (
                <div className="emojiPickerCustom relative" key={item.unified + index} onClick={(e) => { e.stopPropagation(); onEmojiClick(item) }}>
                    <div>
                        {activeEmoji === item.unified ?
                            <div className="absolute left-[-1px] bottom-[-19px] flex items-center justify-center border-[1px] w-6 h-6 border-gray-400 rounded-full">
                                <img src={item.image} alt={item.name} className="absolute w-4 h-4" />
                            </div>
                            :
                            <img src={item.image} alt={item.name} className="absolute w-4 h-4" />
                        }
                    </div>
                </div>
            ))}
        </div>
    );
};

export default EmojiTray;